module.exports = __webpack_public_path__ + "img/menu1-2.73108398.jpg";